import { connect } from 'react-redux';
import Library from '../components/Library';
import { open } from 'store/modules/modal';
import { selectEncoding, deleteEncoding, selected } from '../modules';

const mapStateToProps = state => {
  return {
    selected: selected(state),
    encodings: state.cms.encodings,
  };
};

const mapDispatchToProps = dispatch => ({
  selectEncoding(encoding) {
    dispatch(selectEncoding(encoding));
  },
  confirmDelete(encodingId, fileName) {
    dispatch(
      open({
        modalType: 'confirm',
        modalProps: {
          message: `Delete encoding '${fileName}'?`,
          id: encodingId,
          handleYes: encodingId => {
            dispatch(deleteEncoding(encodingId));
          },
        },
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Library);
